<div class="popup-container flex h-full w-full flex-col">
  <div class="closeDiv flex flex-none basis-[50px] flex-row items-center justify-end">
    <ion-button class="close" fill="clear" shape="round" (click)="closeDialog()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>
  <div class="dialog-content flex flex-1 flex-col pb-20 pl-20 pr-20 pt-0">
    <div *ngIf="innerHTML" [innerHTML]="innerHTML"></div>
    <p *ngIf="!mailToSupport">{{ msg }}</p>
    <p *ngIf="mailToSupport">
      La dirección introducida conlleva un cambio en los gastos de envío. Por favor ponte en contacto con nuestro
      servicio de atención al cliente (<a href="mailto:info@copyfly.es?Subject=Cambio de dirección"
        >info&#64;copyfly.es</a
      >) para hacer el cambio de dirección efectivo. El pedido ha sido pausado.
    </p>
    <div class="flex flex-wrap items-center justify-end">
      <ion-button class="flex-1" fill="outline" expand="block" (click)="closeDialog()"> Cerrar </ion-button>
    </div>
  </div>
</div>
